// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesCannelVersion-SalesChannelCollection-Components-FeaturedImage-css__container--T+SmM"};